module.exports = __webpack_public_path__ + "img/create-success.ef838f44.png";